import { TimeUtil, BrowserUtil, mustache, LocalStorageUtil, AnalyticsTransformer } from '@cue/utility';
import React, { useState, useEffect, createElement, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Select } from '@cue/atoms';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm as useForm$1, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { jsx, useTheme } from '@emotion/react';
import screenfull from 'screenfull';
import { singletonHook } from 'react-singleton-hook';
import { validate, v4 } from 'uuid';
import FileSaver from 'file-saver';
import Fuse from 'fuse.js';
import { Howler } from 'howler';
import { Crisp } from 'crisp-sdk-web';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var useCountdown = function useCountdown(_ref) {
  var end = _ref.end,
    _ref$interval = _ref.interval,
    interval = _ref$interval === void 0 ? 1000 : _ref$interval,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? 'YYYY [years] MM [months] DD [days] HH:mm:ss' : _ref$format;
  var _useState = useState(TimeUtil.getDuration(end === null || end === void 0 ? void 0 : end.diff(TimeUtil.getNowUtc(), 'millisecond'))),
    _useState2 = _slicedToArray(_useState, 2),
    duration = _useState2[0],
    setDuration = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var intervalId;
  useEffect(function () {
    var count = function count() {
      var dur = TimeUtil.getDuration(end === null || end === void 0 ? void 0 : end.diff(TimeUtil.getNowUtc(), 'millisecond'));
      setDuration(dur);
      if (dur.asMilliseconds() <= 999) {
        window.clearInterval(intervalId);
      }
    };
    intervalId = window.setInterval(count, interval);
    return function () {
      return window.clearInterval(intervalId);
    };
  }, [end]);
  var times = {
    years: duration.years(),
    months: duration.months(),
    weeks: duration.weeks(),
    days: duration.days(),
    hours: duration.hours(),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
    asDays: Math.floor(duration.asDays()),
    completed: duration.asMilliseconds() <= 999
  };
  var asString = format.replace('YYYY', replaceDuration(duration.years())).replace('[years]', replaceLabel(duration.years(), t('years'))).replace('MM', replaceDuration(duration.months())).replace('[months]', replaceLabel(duration.months(), t('months'))).replace('DD', replaceDuration(duration.days())).replace('[days]', replaceLabel(duration.days(), t('days'))).replace(/:?HH/, replaceDuration(duration.hours(), true, format ? ':' : ':')).replace(/:?mm/, replaceDuration(duration.minutes(), true, format ? ':' : ':')).replace(/:?ss/,
  // if there are zero seconds left, show 00 instead of nothing
  duration.seconds() > 0 ? replaceDuration(duration.seconds(), true) : '00');
  return _objectSpread2(_objectSpread2({
    duration: duration
  }, times), {}, {
    asString: asString
  });
};
var replaceLabel = function replaceLabel(duration, label) {
  return duration > 0 ? label : '';
};
var replaceDuration = function replaceDuration(duration, leadingZero) {
  var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (duration <= 0) {
    return '';
  }
  if (leadingZero && duration < 10) {
    return "0".concat(duration).concat(postfix);
  }
  return "".concat(duration).concat(postfix);
};

/**
 * This hook can be used to watch a div element's dimensions. When the hook is called,
 * it will return an array, where the first element is the ref that you can pass to your div
 * element and the second element is the dimensions which are updated on window resize
 */
var useDimensions = function useDimensions() {
  var ref = React.useRef(null);
  var _React$useState = React.useState({
      height: 0,
      width: 0
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    boundingBox = _React$useState2[0],
    setBoundingBox = _React$useState2[1];
  React.useEffect(function () {
    var resizeCallback = function resizeCallback() {
      if (ref.current) {
        setBoundingBox(ref.current.getBoundingClientRect());
      } else {
        setBoundingBox(document.body.getBoundingClientRect());
      }
    };
    window.addEventListener('resize', resizeCallback);

    // calling it once to initialize the dimensions with current width and height
    resizeCallback();
    return function () {
      return window.removeEventListener('resize', resizeCallback);
    };
  }, [ref || document.body]);
  return [ref, boundingBox];
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var useFileExists = function useFileExists(props) {
  var url = props.url,
    _props$options = props.options,
    _props$options2 = _props$options === void 0 ? {} : _props$options,
    _props$options2$check = _props$options2.checkEvery,
    checkEvery = _props$options2$check === void 0 ? 2000 : _props$options2$check,
    checkContinuesly = _props$options2.checkContinuesly;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    exists = _useState2[0],
    setExists = _useState2[1];
  var inter;
  var check = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios.get(url);
          case 3:
            response = _context.sent;
            if (!(response.status !== 200)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", false);
          case 6:
            if (!(response.data === '')) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", false);
          case 8:
            return _context.abrupt("return", true);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 11]]);
    }));
    return function check() {
      return _ref.apply(this, arguments);
    };
  }();
  var checkInterval = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var resp;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return check();
          case 2:
            resp = _context2.sent;
            setExists(resp);
            if (resp && !checkContinuesly) {
              clearInterval(inter);
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function checkInterval() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (url) {
      clearInterval(inter);
      setExists(false);
      checkInterval();
      inter = setInterval(function () {
        return checkInterval();
      }, checkEvery);
    }
    return function () {
      return clearInterval(inter);
    };
  }, [url, checkContinuesly, checkEvery]);
  var destroy = function destroy() {
    return clearInterval(inter);
  };
  return {
    exists: exists,
    destroy: destroy
  };
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function useForm() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var schema = props.schema,
    defaultValues = props.defaultValues,
    resolver = props.resolver,
    mode = props.mode;
  var form = useForm$1({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore // TODO
    defaultValues: defaultValues,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore // TODO
    resolver: resolver ? resolver : schema ? yupResolver(schema) : undefined,
    mode: mode
  });
  function registerElement(_ref) {
    var element = _ref.element,
      name = _ref.name,
      props = _ref.props;
    return /*#__PURE__*/createElement(element, _objectSpread2(_objectSpread2({}, form.register(name)), props));
  }
  function registerSelect(_ref2) {
    var name = _ref2.name,
      props = _ref2.props;
    return jsx(Controller, {
      name: name,
      control: form.control,
      render: function render(_ref3) {
        var _ref3$field = _ref3.field,
          _onChange = _ref3$field.onChange,
          value = _ref3$field.value;
        return jsx(Select, _extends({}, props, {
          value: value,
          defaultValue: value,
          onChange: function onChange(e) {
            _onChange(e);
          }
        }));
      }
    });
  }
  var isValidEmail = function isValidEmail(email) {
    return yup.string().email().isValidSync(email);
  };
  var isValidUrl = function isValidUrl(url) {
    return yup.string().url().isValidSync(url);
  };
  return {
    form: form,
    registerElement: registerElement,
    registerSelect: registerSelect,
    isValidEmail: isValidEmail,
    isValidUrl: isValidUrl
  };
}

var useFullscreen = function useFullscreen() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIos = _useState2[0],
    setIsIos = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFullscreen = _useState4[0],
    setIsFullscreen = _useState4[1];
  var detectFullscreenChange = function detectFullscreenChange() {
    return setIsFullscreen(screenfull.isFullscreen);
  };
  var endFullscreenCallback = function endFullscreenCallback() {
    return setIsFullscreen(false);
  };
  useEffect(function () {
    var ios = BrowserUtil.isIOs();
    setIsIos(ios);
    if (!ios) {
      screenfull.on('change', detectFullscreenChange);
      return function () {
        screenfull.off('change', detectFullscreenChange);
      };
    } else {
      document.addEventListener('webkitendfullscreen', endFullscreenCallback);
    }
  }, []);
  var enter = function enter(wrapper) {
    // Search for a video element on iOS
    var _fsElement = isIos ? wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('video') : wrapper;
    if (_fsElement) {
      try {
        isIos ? /* eslint-disable */
        // @ts-ignore
        _fsElement.webkitEnterFullscreen() : /* eslint-enable */
        screenfull.request(_fsElement);
      } catch (e) {
        console.warn('Could not enter fullscreen');
      }
    }
    setIsFullscreen(true);
  };
  var exit = function exit() {
    if (!isIos) {
      screenfull.exit();
    }
    setIsFullscreen(false);
  };
  var toggle = function toggle(wrapper) {
    if (!isFullscreen) {
      enter(wrapper);
    } else {
      exit();
    }
  };
  return {
    isFullscreen: isFullscreen,
    enter: enter,
    exit: exit,
    toggle: toggle
  };
};

var defaultState$1 = {
  isLoading: true,
  hash: null,
  updateHash: function updateHash() {
    return null;
  },
  reInitHash: function reInitHash() {
    return null;
  }
};
var getSystemHash = function getSystemHash() {
  return window.location.hash.replace('#', '');
};
var useHashDataImpl = function useHashDataImpl() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(function () {
      return getSystemHash();
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    hash = _useState4[0],
    setHash = _useState4[1];
  var hashChangeHandler = useCallback(function () {
    setHash(getSystemHash());
  }, []);
  useEffect(function () {
    // remove direct links
    var initialhash = getSystemHash();
    if (validate(initialhash)) ;
    window.addEventListener('popstate', hashChangeHandler);
    setIsLoading(false);
    return function () {
      window.removeEventListener('popstate', hashChangeHandler);
    };
  }, []);
  var reInitHash = function reInitHash() {
    // remove direct links
    var initialhash = getSystemHash();
    if (validate(initialhash)) ;
  };
  var updateHash = useCallback(function (newHash, silentReplace) {
    if (!newHash) return;
    if (newHash !== hash) {
      {
        if (silentReplace) {
          history.replaceState(null, '', "#".concat(newHash));
        } else {
          window.location.hash = newHash;
        }
      }
      setHash(newHash);
    }
  }, [hash]);
  return {
    hash: hash,
    isLoading: isLoading,
    updateHash: updateHash,
    reInitHash: reInitHash
  };
};
var useHash = singletonHook(defaultState$1, useHashDataImpl);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var _class;
// https://www.kanzaki.com/docs/ical/dateTime.html
var ICS_TIME_FORMAT = 'YYYYMMDDTHHmmss[Z]';

/**
 * This Utility can be used to create an icalendar object
 * For more info on this format, you can have a look at the respective RFC:
 *
 * https://tools.ietf.org/html/rfc5545
 */
var IcsUtil = /*#__PURE__*/function () {
  function IcsUtil() {
    _classCallCheck(this, IcsUtil);
  }
  _createClass(IcsUtil, null, [{
    key: "getOptionalProperties",
    value:
    /**
     * Adds all optional properties to an event
     * TODO: there are a lot more properties available that may be added here
     *
     * @param param0
     */
    function getOptionalProperties(_ref) {
      var url = _ref.url,
        description = _ref.description,
        end = _ref.end,
        location = _ref.location,
        alarm = _ref.alarm;
      var result = [];
      if (url) {
        result.push("URL:".concat(url));
      }
      if (description) {
        result.push("DESCRIPTION:".concat(description.replace(/<br\s*\/?>|\n/gm, '\\n').replace(/&/gm, '%26')));
      }
      if (end) {
        result.push("DTEND:".concat(end.format(ICS_TIME_FORMAT)));
      }
      if (location) {
        result.push("LOCATION:".concat(location));
      }
      if (alarm) {
        result.push("BEGIN:VALARM");
        result.push("TRIGGER:-PT".concat(alarm, "M"));
        result.push("ACTION:DISPLAY");
        result.push("END:VALARM");
      }
      return result;
    }
  }]);
  return IcsUtil;
}();
_class = IcsUtil;
_defineProperty(IcsUtil, "buildIcs", function (icsEvent) {
  var events = Array.isArray(icsEvent) ? icsEvent : [icsEvent];
  var calendarHead = ['BEGIN:VCALENDAR', 'VERSION:2.0',
  // https://tools.ietf.org/html/rfc5545#section-3.7.3
  // https://en.wikipedia.org/wiki/Formal_Public_Identifier
  'PRODID:-//cueconcept ICS//EN'];
  var eventHead = ['BEGIN:VEVENT'];
  var eventTail = ['END:VEVENT'];
  var calendarTail = ['END:VCALENDAR'];
  var eventsData = events.map(function (event) {
    var requiredEventProperties = [// https://icalendar.org/New-Properties-for-iCalendar-RFC-7986/5-3-uid-property.html
    "UID:".concat(v4()), "DTSTAMP:".concat(TimeUtil.getNowUtc().format(ICS_TIME_FORMAT)), "DTSTART:".concat(event.start.format(ICS_TIME_FORMAT)), "SUMMARY:".concat(event.subject.replace(/<br\s*\/?>|\n/gm, '\\n').replace(/&/gm, '%26'))];
    var optionalEventProperties = _class.getOptionalProperties(event);
    return [].concat(eventHead, requiredEventProperties, _toConsumableArray(optionalEventProperties), eventTail).join('\r\n');
  });
  var calendarEvent = [].concat(calendarHead, _toConsumableArray(eventsData), calendarTail);

  // each line is separated by carriage return and line feed characters
  // https://tools.ietf.org/html/rfc5545#section-3.1
  return calendarEvent.join('\r\n');
});

var useIcs = function useIcs() {
  var download = function download(icsEvent, mustacheData) {
    var _navigator;
    var filename = 'calendar';
    if (Array.isArray(icsEvent)) {
      icsEvent = icsEvent.map(function (event) {
        return _objectSpread2(_objectSpread2({}, event), {}, {
          subject: mustache(event === null || event === void 0 ? void 0 : event.subject, mustacheData),
          description: mustache((event === null || event === void 0 ? void 0 : event.description) || '', mustacheData)
        });
      });
      filename = icsEvent.map(function (e) {
        return e.subject;
      }).join(' / ');
    } else {
      var _icsEvent, _icsEvent2;
      icsEvent.subject = mustache((_icsEvent = icsEvent) === null || _icsEvent === void 0 ? void 0 : _icsEvent.subject, mustacheData);
      icsEvent.description = mustache(((_icsEvent2 = icsEvent) === null || _icsEvent2 === void 0 ? void 0 : _icsEvent2.description) || '', mustacheData);
      filename = icsEvent.subject;
    }
    var icalFormat = IcsUtil.buildIcs(icsEvent);
    var platform = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.platform;
    if (/iPad|iPhone|iPod/.test(platform) || platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      window.open("data:text/calendar;charset=utf8,".concat(encodeURI(icalFormat)));
      return;
    }
    var blob = new Blob([icalFormat], {
      type: 'text/calendar;charset=utf-8'
    });
    FileSaver.saveAs(blob, "".concat(filename, ".ics"));
  };
  return {
    download: download
  };
};

var useMailto = function useMailto() {
  var send = function send(_ref, mustacheData) {
    var subject = _ref.subject,
      body = _ref.body;
    var MAX_MAILTO_LENGTH = 2046;
    var mailto = "mailto:?subject=".concat(mustache(subject, mustacheData).replace(/<br\s*\/?>|\n/gm, '\\n').replace(/&/gm, '%26'), "&body=").concat(mustache(body, mustacheData).replace(/<br\s*\/?>|\n/gm, '%0D%0A').replace(/&/gm, '%26'));
    if (mailto.length > MAX_MAILTO_LENGTH) {
      console.error("Warning, Mailto contains more than 2046 characters. IE and Edge won't open the mail programm.", mailto);
    }
    mailto = mailto.substring(0, MAX_MAILTO_LENGTH);
    window.location.href = mailto;
  };
  return {
    send: send
  };
};

var useMq = function useMq() {
  var theme = useTheme();
  var _useState = useState(theme !== null && theme !== void 0 && theme.mq ? Object.keys(theme.mq).map(function (mq) {
      var _theme$mq$mq$match;
      var size = (_theme$mq$mq$match = theme.mq[mq].match(/(\d+)/)) === null || _theme$mq$mq$match === void 0 ? void 0 : _theme$mq$mq$match[0];
      if (!size) {
        console.warn("window size not found in media query - ".concat(theme.mq[mq]));
      }
      return {
        mq: mq,
        query: theme.mq[mq].replace('@media', ''),
        active: false,
        screenSize: size ? +size : undefined
      };
    }) : []),
    _useState2 = _slicedToArray(_useState, 2),
    mqStates = _useState2[0],
    setMqStates = _useState2[1];
  var checkQueries = function checkQueries() {
    setMqStates(function (prevState) {
      return prevState.map(function (ps) {
        return _objectSpread2(_objectSpread2({}, ps), {}, {
          active: window.matchMedia(ps.query).matches
        });
      });
    });
  };
  useEffect(function () {
    checkQueries();
    window.addEventListener('resize', checkQueries);
    return function () {
      window.removeEventListener('resize', checkQueries);
    };
  }, []);
  var isMq = function isMq(index) {
    var _mqStates$find;
    return (mqStates === null || mqStates === void 0 || (_mqStates$find = mqStates.find(function (_ref) {
      var mq = _ref.mq;
      return mq === index;
    })) === null || _mqStates$find === void 0 ? void 0 : _mqStates$find.active) || false;
  };
  var getMq = function getMq(size) {
    return mqStates === null || mqStates === void 0 ? void 0 : mqStates.find(function (_ref2) {
      var mq = _ref2.mq;
      return mq === size;
    });
  };
  return {
    mqStates: mqStates,
    isMq: isMq,
    getMq: getMq
  };
};

/**
 * This function returns a ref that can be passed on to a component for
 * which a click outside of that component shall be detected
 * This can be used in a functional component only
 *
 * @param callback function that is called when a click outside the element
 *                 is detected
 */
var useBackdropClickListener = function useBackdropClickListener(_ref) {
  var callback = _ref.callback,
    _ref$ref = _ref.ref,
    ref = _ref$ref === void 0 ? React.useRef() : _ref$ref;
  React.useEffect(function () {
    var clickHandler = function clickHandler(event) {
      // this determines if the callback should be called
      var shouldCallCallback = function shouldCallCallback() {
        if (!callback) {
          return false;
        }

        // if there is no ref or no current element, don't call the cb
        if (!ref || !ref.current) {
          return false;
        }
        return ref.current === event.target;
      };
      if (shouldCallCallback() && callback) {
        callback();
      }
    };
    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  });
  return ref;
};
var useOnClickOutside = function useOnClickOutside() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : React.useRef(null);
  var handler = arguments.length > 1 ? arguments[1] : undefined;
  React.useEffect(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current && ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/* eslint-disable sort-exports/sort-exports */

function useQueryParams() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var locationOption = options.location,
    navigate = options.navigate,
    intitialParams = options.intitialParams;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    updateCount = _React$useState2[0],
    setUpdateCount = _React$useState2[1];
  var location = React.useRef();
  React.useEffect(function () {
    if (!locationOption && navigate || locationOption && !navigate) {
      console.warn("\u26A0\uFE0F useQueryParams(): Please consider passing both location & navigate from your router to useQueryParams()\n      \n      It is highly recommended to chose who is responsibile for both navigate() & location.\n      While passing only one of them will mostly work, it can lead to some inconsistencies depending on the router.\n      ");
    }
  }, [locationOption, navigate]);
  React.useEffect(function () {
    location.current = locationOption || (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined ? window.location : undefined;
    triggerUpdate();
  }, [locationOption]);
  function updateLocation() {
    if (locationOption) return;
    location.current = window.location;
  }
  function triggerUpdate() {
    /* inconsistentSettings means: navigate() function from router (or custom), but no location passed as prop.
    /*
    /* It is recommended to choose between providing both or letting useQueryParams handle both.
    /* e.g. @reach/router´s navigate() returns a Promise, while react-router does not, leading to potenital race conditions
    /*
    /* To still make it work inconsistentSettings will introduce a little delay for the updater function to wait 
    /* for the updated location to be available.
    */
    var inconsistentSettings = navigate && !locationOption;
    setTimeout(function () {
      updateLocation();
      setUpdateCount(function (updateCount) {
        return updateCount + 1;
      });
    }, inconsistentSettings ? 50 : 0);
  }

  // if no location from options - add own listener
  React.useEffect(function () {
    if (locationOption) return;
    window.addEventListener('popstate', triggerUpdate);
    updateLocation();
    return function () {
      window.removeEventListener('popstate', triggerUpdate);
    };
  }, []);

  // set intitialParams
  React.useEffect(function () {
    if (!intitialParams || !location.current) return;
    if (navigate) {
      navigate('?' + createSearchParams(intitialParams).toString());
    } else {
      var _url = new URL("".concat(location.current.origin).concat(location.current.pathname));
      var newUrl = "".concat(_url, "?").concat(createSearchParams(intitialParams).toString());
      window.history.pushState({}, "", newUrl);
    }
    triggerUpdate();
  }, []);
  var searchParams = React.useMemo(function () {
    // use window.location if location.current is not ready
    var isBrowser = typeof window !== 'undefined';
    var searchParams = location.current ? Object.fromEntries(new URLSearchParams(location.current.search)) : isBrowser ? Object.fromEntries(new URLSearchParams(window.location.search)) : {};
    return convertObjectToSafeValues(searchParams);
  }, [updateCount]);
  var setSearchParams = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(nextInit) {
      var newQueryParams, _url2, hasParams, queryString, newUrl;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!nextInit || !location.current)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            newQueryParams = typeof nextInit === 'function' ? nextInit(searchParams) : nextInit;
            if (!navigate) {
              _context.next = 8;
              break;
            }
            _context.next = 6;
            return navigate('?' + createSearchParams(newQueryParams).toString() + location.current.hash);
          case 6:
            _context.next = 13;
            break;
          case 8:
            _url2 = new URL("".concat(location.current.origin).concat(location.current.pathname));
            hasParams = Object.keys(newQueryParams).length;
            queryString = hasParams ? "?".concat(createSearchParams(newQueryParams).toString()) : '';
            newUrl = "".concat(_url2).concat(queryString).concat(location.current.hash);
            window.history.pushState({}, "", newUrl);
          case 13:
            triggerUpdate();
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [searchParams, navigate, location, updateCount]);
  return [searchParams, setSearchParams];
}
function convertToComplexValue(val) {
  if (typeof val === 'string') {
    try {
      return JSON.parse(val);
    } catch (e) {
      console.warn(val, 'is not JSON parsable');
    }
  }
  return String(val);
}
function convertToSafeValue(val) {
  if (val === null || val === undefined) {
    return '';
  }
  if (_typeof(val) === 'object') {
    return JSON.stringify(val);
  }
  return String(val);
}
function convertObjectToSafeValues(obj) {
  var deepSearchParams = Object.keys(obj).reduce(function (res, key) {
    return _objectSpread2(_objectSpread2({}, res), {}, _defineProperty({}, key, convertToComplexValue(obj[key])));
  }, {});
  return deepSearchParams;
}
function createSearchParams() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new URLSearchParams(Object.keys(init).reduce(function (memo, key) {
    var value = init[key];
    return memo.concat([[key, convertToSafeValue(value)]]);
  }, []));
}

/* eslint-enable sort-exports/sort-exports */

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded = ["refIndex", "matches", "score"];
function useSearch(_ref) {
  var input = _ref.input,
    keys = _ref.keys,
    limit = _ref.limit,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {
      threshold: 0
    } : _ref$options;
  var index = Fuse.createIndex(keys, input);
  var fuse = new Fuse(input, _objectSpread2(_objectSpread2({
    keys: keys,
    includeScore: true,
    includeMatches: true,
    findAllMatches: true
  }, options), {}, {
    ignoreLocation: true
  }), index);
  var fuse_suggestions = new Fuse(input, _objectSpread2(_objectSpread2({
    keys: keys,
    includeScore: true,
    includeMatches: true
  }, options), {}, {
    threshold: 0.4
  }), index);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    matches = _useState2[0],
    setMatches = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    result = _useState4[0],
    setResult = _useState4[1];
  var getMatches = function getMatches(arr, input, limit) {
    var matchedWords = arr.flatMap(function (item) {
      var _item$matches;
      return item === null || item === void 0 || (_item$matches = item.matches) === null || _item$matches === void 0 ? void 0 : _item$matches.flatMap(function (match) {
        var _match$value;
        return (match === null || match === void 0 || (_match$value = match.value) === null || _match$value === void 0 ? void 0 : _match$value.split(' ')) || [];
      });
    }).filter(function (word) {
      return word === null || word === void 0 ? void 0 : word.toLowerCase().includes(input.toLowerCase());
    });
    var ret = Array.from(new Set(matchedWords));
    if (limit) return ret.splice(0, limit) || [];
    return ret;
  };
  var reset = function reset() {
    setMatches([]);
    setResult([]);
  };
  var suggestions = function suggestions(input) {
    var searchResult = fuse_suggestions.search(input);
    setMatches(getMatches(searchResult, input, limit));
  };
  var search = function search(input) {
    var searchResult = fuse.search(input);
    setResult(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchResult.map(function (_ref2) {
      _ref2.refIndex;
        _ref2.matches;
        _ref2.score;
        var keepAttrs = _objectWithoutProperties(_ref2, _excluded);
      return keepAttrs.item;
    }));
  };
  return {
    matches: matches,
    result: result,
    search: search,
    suggestions: suggestions,
    reset: reset,
    input: input
  };
}

var defaultState = {
  savedSoundStatus: false,
  canSoundPlay: false,
  isLoading: true,
  saveSoundStatus: function saveSoundStatus() {
    return null;
  }
};
var useSoundImpl = function useSoundImpl() {
  var _Howler$ctx, _Howler$ctx3;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];

  // TODO
  var _useState3 = useState(((_Howler$ctx = Howler.ctx) === null || _Howler$ctx === void 0 ? void 0 : _Howler$ctx.state) === 'running'),
    _useState4 = _slicedToArray(_useState3, 2),
    canSoundPlay = _useState4[0],
    setCanSoundPlay = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    savedSoundStatus = _useState6[0],
    setSoundSavedStatus = _useState6[1];
  var saveSoundStatus = function saveSoundStatus(status) {
    LocalStorageUtil.set('soundEnabled', status.toString());
    setSoundSavedStatus(status);
    if (!status) {
      Howler.stop();
    }
  };
  useEffect(function () {
    setIsLoading(false);
    setSoundSavedStatus(LocalStorageUtil.get('soundEnabled') === 'true' && canSoundPlay);
  }, []);
  useEffect(function () {
    var _Howler$ctx2;
    if (!isLoading) setCanSoundPlay(((_Howler$ctx2 = Howler.ctx) === null || _Howler$ctx2 === void 0 ? void 0 : _Howler$ctx2.state) === 'running');
  }, [(_Howler$ctx3 = Howler.ctx) === null || _Howler$ctx3 === void 0 ? void 0 : _Howler$ctx3.state, isLoading]);
  return {
    canSoundPlay: canSoundPlay,
    savedSoundStatus: savedSoundStatus,
    isLoading: isLoading,
    saveSoundStatus: saveSoundStatus
  };
};
var useSound = singletonHook(defaultState, useSoundImpl);

var useCrispChat = function useCrispChat(props) {
  var CRISP_WEBSITE_ID = props.CRISP_WEBSITE_ID,
    _props$options = props.options,
    options = _props$options === void 0 ? {} : _props$options,
    needCookieConsent = props.needCookieConsent;
  useEffect(function () {
    if (needCookieConsent) {
      var cookies = LocalStorageUtil.get('cookieConsent');
      if (!(cookies === 'all' || cookies === 'required')) {
        console.warn(cookies, 'Skipping chat because of cookie settings');
        return;
      }
    }
    Crisp.configure(CRISP_WEBSITE_ID, options);
  }, [needCookieConsent]);
  var load = React.useCallback(function () {
    Crisp.load();
  }, []);
  var setUser = React.useCallback(function (user) {
    Crisp.user.setNickname(user);
  }, []);
  return {
    load: load,
    chat: Crisp.chat,
    setUser: setUser
  };
};

var mediaAnalytics = AnalyticsTransformer === null || AnalyticsTransformer === void 0 ? void 0 : AnalyticsTransformer.getMediaTracker();
var useMediaAnalytics = function useMediaAnalytics(_ref) {
  var player = _ref.player,
    title = _ref.title,
    src = _ref.src,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'VoD' : _ref$type;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    internalPlayer = _useState2[0],
    setInternalPlayer = _useState2[1];
  var tracker = useMemo(function () {
    return mediaAnalytics && src && new mediaAnalytics.MediaTracker(type, mediaAnalytics.mediaType.VIDEO, "".concat(src));
  }, [src, title]);
  useEffect(function () {
    if (!internalPlayer && player !== null && player !== void 0 && player.getInternalPlayer()) {
      setInternalPlayer(player === null || player === void 0 ? void 0 : player.getInternalPlayer());
    }
  }, [title, player, player === null || player === void 0 ? void 0 : player.getInternalPlayer()]);
  useEffect(function () {
    if (internalPlayer && mediaAnalytics) {
      tracker.setWidth(internalPlayer.clientWidth);
      tracker.setHeight(internalPlayer.clientHeight);
      tracker.setFullscreen(mediaAnalytics.element.isFullscreen(internalPlayer));
      tracker.setMediaTitle(title);
      console.log('MATOMO resource', title);
      console.log('MATOMO mediaAnalytics', mediaAnalytics, player, internalPlayer);
      removeListeners();
      var capture = true;
      internalPlayer.addEventListener('play', onPlay, capture);
      internalPlayer.addEventListener('pause', onPause, capture);
      internalPlayer.addEventListener('ended', onEnded, capture);
      internalPlayer.addEventListener('seeking', onSeeking, capture);
      internalPlayer.addEventListener('seeked', onSeeked, capture);
      internalPlayer.addEventListener('timeupdate', onTimeUpdate, capture);
      tracker.trackUpdate();
    }
    return function () {
      console.log('MATOMO currentPlayer REMOVE', player);
      removeListeners();
    };
  }, [title, internalPlayer, mediaAnalytics]);
  var removeListeners = function removeListeners() {
    if (internalPlayer) {
      internalPlayer.removeEventListener('play', onPlay);
      internalPlayer.removeEventListener('pause', onPause);
      internalPlayer.removeEventListener('ended', onEnded);
      internalPlayer.removeEventListener('seeking', onSeeking);
      internalPlayer.removeEventListener('seeked', onSeeked);
      internalPlayer.removeEventListener('timeupdate', onTimeUpdate);
    }
  };
  var onPlay = function onPlay() {
    tracker === null || tracker === void 0 || tracker.play();
  };
  var onPause = function onPause() {
    tracker === null || tracker === void 0 || tracker.pause();
  };
  var onEnded = function onEnded() {
    tracker === null || tracker === void 0 || tracker.finish();
  };
  var onSeeked = function onSeeked() {
    tracker === null || tracker === void 0 || tracker.setMediaProgressInSeconds(player === null || player === void 0 ? void 0 : player.getCurrentTime());
    tracker === null || tracker === void 0 || tracker.setMediaTotalLengthInSeconds(player === null || player === void 0 ? void 0 : player.getDuration());
    tracker === null || tracker === void 0 || tracker.seekFinish();
  };
  var onSeeking = function onSeeking() {
    tracker === null || tracker === void 0 || tracker.seekStart();
  };
  var onTimeUpdate = function onTimeUpdate() {
    tracker === null || tracker === void 0 || tracker.setMediaProgressInSeconds(player === null || player === void 0 ? void 0 : player.getCurrentTime());
    tracker === null || tracker === void 0 || tracker.setMediaTotalLengthInSeconds(player === null || player === void 0 ? void 0 : player.getDuration());
    tracker === null || tracker === void 0 || tracker.update();
  };
  /* eslint-disable @typescript-eslint/no-empty-function */
  var registerMedia = function registerMedia() {};
  var removeMedia = function removeMedia() {};
  /* eslint-enable @typescript-eslint/no-empty-function */

  return {
    registerMedia: registerMedia,
    removeMedia: removeMedia
  };
};

export { createSearchParams, getSystemHash, useBackdropClickListener, useCountdown, useCrispChat, useDimensions, useFileExists, useForm, useFullscreen, useHash, useIcs, useMailto, useMediaAnalytics, useMq, useOnClickOutside, useQueryParams, useSearch, useSound };
